import { cva } from '@/styled-system/css';

export const closeButtonRecipe = cva({
  base: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'inline-flex',
    justifyContent: 'center',
    position: 'relative',
    transition: {
      _motionReduce: 'none',
      _motionSafe:
        'box-shadow 200ms ease, background-color 200ms ease, border-color 200ms ease, color 200ms ease',
    },
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.Button.default} var(--shadow-color)',
      _focusVisible:
        'inset 0 0 0 {borderWidths.Button.default} var(--shadow-color), {shadows.focus}',
    },
    height: 'CloseButton',
    width: 'CloseButton',
    borderRadius: 'CloseButton',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
    onImpact: {
      true: {
        backgroundColor: {
          base: 'CloseButton.bg.onImpact.default',
        },
        boxShadowColor: {
          base: 'CloseButton.border.onImpact.default',
        },
        color: {
          base: 'CloseButton.icon.onImpact.default',
        },
      },
      false: {
        backgroundColor: {
          base: 'CloseButton.bg.default',
        },
        boxShadowColor: {
          base: 'CloseButton.border.default',
        },
        color: {
          base: 'CloseButton.icon.default',
        },
      },
    },
  },
  compoundVariants: [
    {
      onImpact: true,
      disabled: false,
      css: {
        backgroundColor: {
          _hover: 'CloseButton.bg.onImpact.hover',
          _active: 'CloseButton.bg.onImpact.pressed',
        },
        boxShadowColor: {
          _hover: 'CloseButton.border.onImpact.hover',
          _active: 'CloseButton.border.onImpact.pressed',
        },
        color: {
          _hover: 'CloseButton.icon.onImpact.hover',
          _active: 'CloseButton.icon.onImpact.pressed',
        },
      },
    },
    {
      onImpact: false,
      disabled: false,
      css: {
        backgroundColor: {
          _hover: 'CloseButton.bg.hover',
          _active: 'CloseButton.bg.pressed',
        },
        boxShadowColor: {
          _hover: 'CloseButton.border.hover',
          _active: 'CloseButton.border.pressed',
        },
        color: {
          _hover: 'CloseButton.icon.hover',
          _active: 'CloseButton.icon.pressed',
        },
      },
    },
  ],
});
